import { render } from "./DrawerInput.vue?vue&type=template&id=18afc3f6"
import script from "./DrawerInput.vue?vue&type=script&lang=js"
export * from "./DrawerInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__